'use client'
import { getEntryPoint as getEntryPoint$1 } from '@zerodev/sdk/constants';
import { ProviderEntryPointVersionEnum } from '@dynamic-labs/sdk-api-core';
import { logger } from './logger.js';

const getEntryPoint = (entryPoint) => {
    if (entryPoint === undefined ||
        entryPoint === ProviderEntryPointVersionEnum.V7) {
        return getEntryPoint$1('0.7');
    }
    else if (entryPoint === ProviderEntryPointVersionEnum.V6) {
        return getEntryPoint$1('0.6');
    }
    else {
        logger.error('Invalid entry point version', entryPoint);
        return getEntryPoint$1('0.7');
    }
};

export { getEntryPoint };
